import { render, staticRenderFns } from "./RelatedTopics.vue?vue&type=template&id=8e0ddb8a"
import script from "./RelatedTopics.vue?vue&type=script&setup=true&lang=ts"
export * from "./RelatedTopics.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RoundedButton: require('/vercel/path0/components/RoundedButton.vue').default})
